import React from "react";
import { useAuth } from "../lib/auth";
import UsageAnalytics from "../components/UsageAnalytics";
import { CreditCard, Building2, Users } from "lucide-react";

export default function PlatformAdmin() {
  const { user } = useAuth();

  if (!user?.is_platform_owner) {
    return (
      <div className="max-w-4xl mx-auto px-6 py-20 text-center" data-testid="platform-admin-forbidden">
        <div className="font-mono-cal text-[10px] uppercase tracking-widest text-[#FF4F00] mb-2">[FORBIDDEN]</div>
        <h1 className="font-display font-bold text-3xl">Platform owner access required</h1>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-12" data-testid="platform-admin-page">
      <div className="flex items-baseline justify-between flex-wrap gap-3 mb-2">
        <div>
          <div className="font-mono-cal text-[11px] uppercase tracking-[0.2em] text-[#FF4F00] mb-3">[ GOD MODE ]</div>
          <h1 className="font-display font-bold text-5xl tracking-tight">Platform admin</h1>
        </div>
        <div className="flex flex-wrap gap-2" data-testid="platform-admin-nav">
          <a
            href="/admin/platform/plans"
            className="cal-btn"
            data-testid="platform-plans-link"
          >
            <CreditCard size={14} className="inline mr-1.5" /> Subscription plans →
          </a>
          <a
            href="/admin/platform/orgs"
            className="cal-btn"
            data-testid="platform-orgs-link"
          >
            <Building2 size={14} className="inline mr-1.5" /> Organizations →
          </a>
          <a
            href="/admin/platform/users"
            className="cal-btn"
            data-testid="platform-users-link"
          >
            <Users size={14} className="inline mr-1.5" /> Manage all users →
          </a>
        </div>
      </div>
      <p className="text-[#666] mb-10">Real-time usage across every tenant. Jump into subscription plans, organizations, or all users above.</p>

      <UsageAnalytics scope="platform" />
    </div>
  );
}
